import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Switch, message as toaster } from 'antd';
import { useDispatch } from 'react-redux';
import { updateStatus } from 'store/commonSlice';

const { confirm } = Modal;

export default function StatusAction({ userType, id, statusData = false }) {
	const dispatch = useDispatch();

	function handleOk() {
		const data = {
			update_type: 'status',
			data: { id, type: userType, is_active: !statusData },
		};

		dispatch(updateStatus(data)).then(() => {
			toaster.success('Status updated successfully');
			setTimeout(() => {
				window.location.reload();
			}, 500);
		});
	}

	function showConfirm() {
		const status = statusData === true ? 'Inactive' : 'Active';
		confirm({
			title: `Do you Want to chanage the status to ${status}?`,
			onOk() {
				console.log('OK');
				handleOk();
			},
		});
	}

	return (
		<Switch
			checked={statusData}
			onChange={showConfirm}
			checkedChildren="Active"
			unCheckedChildren="InActive"
		/>
	);
}

StatusAction.propTypes = {
	statusData: PropTypes.bool,
	userType: PropTypes.string,
	id: PropTypes.number,
};
